import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import cc from 'classcat'

import Icon from '../Icon'

const TabBarDropdown = ({ title, icon, itemClass, children, id }) => {
  const [isDropdownShown, setIsDropdownShown] = useState(false)
  const dropdownRef = useRef(null)
  
  // Handle click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && isDropdownShown) {
        setIsDropdownShown(false)
      }
    }
    
    // Add event listener
    document.addEventListener('mousedown', handleClickOutside)
    
    // Clean up
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isDropdownShown])
  
  const toggleDropdown = () => setIsDropdownShown(!isDropdownShown)
  
  const renderDropdown = (content) => (
    <div className="tab-bar-dropdown-menu">
      {content}
    </div>
  )
  
  return (
    <div
      ref={dropdownRef}
      className={cc([itemClass, 'tab-bar-dropdown', 'right-tab-bar-item'])}
      onClick={toggleDropdown}
      id={id}
      onKeyDown={(e) => e.key === 'Enter' && toggleDropdown()}
      role="button"
      tabIndex={0}>
      <div className="tab-bar-dropdown-title">
        <Icon name={icon} />
        <span>
          {title}
        </span>
      </div>
      {isDropdownShown ? renderDropdown(children) : null}
    </div>
  )
}

TabBarDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  itemClass: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
}

TabBarDropdown.defaultProps = {
  itemClass: [],
  icon: null,
}

export default TabBarDropdown
